export default __webpack_public_path__ + "static/media/logo.7c7dadea.png";